<template>
    <div v-bind:class="'alert-'+alertMessage.alert_context" class="alert alert-block alert">

        <span class="fa fa-times-circle fa-2x close-btn"
              @click="$emit('setAlertAsClosed')"
              v-if="!alertMessage.is_confirmation_needed">
        </span>

        <Spinner v-bind:title="'Sending Alert ...'" v-if="isSaving" ></Spinner>

        <strong @click="$emit('openAlert')" class="title-message-open-alert" v-show="!isSaving">
            {{ alertMessage.message }}
            <template v-if="alertMessage.isConfirmationMessageOpen ">
                <i class="fa fa-times pull-right  "></i>
            </template>
            <template v-else>
                <i class="fa fa-envelope pull-right  "></i>
            </template>
        </strong>

        <div class="confirmation_message" v-show="alertMessage.isConfirmationMessageOpen && !isSaving ">

            <p v-if="alertMessage.job">
                <br>
                <strong>{{'You should make a choice if not the job will be considered as accepted'|trans}}</strong><br><br>

                {{'Job'|trans}} #{{ alertMessage.job.id|TruncateJobNumber }}<br>
                <strong>{{'Warranty Scheduled'|trans }}</strong> : {{'on'|trans }}  {{ $moment(alertMessage.job.date_job_start).format('DD MMM à H[h]mm') }} <br>
                ({{'The last date of the intervention' |trans }} {{ $moment(alertMessage.parent_job_intervention_date).format('DD MMM à H[h]mm') }})<br>
                {{'Customer'|trans}} : {{ alertMessage.job.customer.lastname }}<br>
                {{'Intervention address' | trans }} : {{ alertMessage.job.customer_address_intervention.number.toLowerCase() }} {{ alertMessage.job.customer_address_intervention.street.toLowerCase() }}, {{ alertMessage.job.customer_address_intervention.zip_code }} {{ alertMessage.job.customer_address_intervention.city }} <br>
                {{'Job Description'|trans}} : {{ alertMessage.job.job_description }}
            </p>

            <div class="row">
                <div class="col-xs-4">
                    <a class="btn btn-warning full-width" :href="'tel: +'+alertMessage.customer_default_phone">Call Client</a>
                </div>
                <div class="col-xs-4">
                    <button class="btn btn-default full-width" @click="acceptanceButton(false)">Refuse </button>
                </div>
                <div class="col-xs-4">
                    <button class="btn btn-primary full-width" @click="acceptanceButton(true)">Accept </button>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-6"></div>
                <div class="col-xs-6 text-right">
                    <button @click="$emit('snoozeAlert', defaultSnoozeHours)" class="btn btn-primary" v-bind:disabled="isSnoozedTimerEnable">{{'Reminder in 2h'|trans}}</button>
                </div>
            </div>

            <div class="" v-if="showRefuseForm===true">
                <textarea v-model="alertMessage.confirmationMessage" class="form-control"> </textarea>
                <p>{{'Please write at least'|trans}} {{ minimumCharacters }} {{ 'chars'|trans}}</p>
                <button class="btn btn-primary full-width" @click="submitResponse()" v-bind:disabled="!isEnabled" >Submit </button>
            </div>

        </div>

    </div>
</template>

<script>
    import Spinner from '../../Spinner';

    export default {
        props: {
            alertMessage : Object,
            isSnoozedTimerEnable : false
        },
        data(){
            return {
                minimumCharacters : 15,
                defaultSnoozeHours : 2,
                isSaving: false,
                showRefuseForm: false,
                acceptanceWarranty : null,
            }
        },
        methods: {
            acceptanceButton(acceptenceResponse){
                if(acceptenceResponse===true){
                    this.acceptanceWarranty = true;
                    this.submitResponse();
                }else{
                    this.acceptanceWarranty = false;
                    this.showRefuseForm = true;
                }
            },
            async submitResponse() {
                this.isSaving = true;
                await this.$api.alert.responseOfAlertJobWarranty(this.alertMessage, this.acceptanceWarranty);
                this.$emit('hideAlert');
                this.isSaving = false;
            }
        },
        computed : {
            isEnabled(){
                return (this.alertMessage.confirmationMessage.length > this.minimumCharacters )
            }
        },
        components: {
            Spinner
        },
        filters: {
            TruncateJobNumber(value) {
                return value.toString().substr(2, value.toString().length);
            },
        }
    }
</script>
<style scoped>
    .text-right{
        text-align: right;
    }
</style>
